import { Rotate3d, Plane, Clapperboard } from "lucide-react";
import { Reveal, SectionHeader } from "@/components/Reveal";

const PILLARS = [
  {
    icon: Rotate3d,
    title: "360° Room Tours",
    text: "Immersive walkthroughs your buyers can explore from anywhere — every room, every angle, on any device.",
    examples: ["Interactive walkthroughs", "MLS & website embeds", "Virtual open houses"],
  },
  {
    icon: Plane,
    title: "Drone Flights",
    text: "Cinematic aerial footage that sells the location, not just the listing — the lot, the street, the whole story.",
    examples: ["Property overviews", "Neighborhood context", "Lot & land showcases"],
  },
  {
    icon: Clapperboard,
    title: "Promo Clips",
    text: "Short, branded clips built for ads and social feeds — cut to your company's look, voice, and market.",
    examples: ["Just-listed teasers", "Agent brand spots", "Ad campaigns"],
  },
];

export const OfferSection = () => (
  <section id="offer" className="bg-white py-24 sm:py-32" data-testid="offer-section">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <SectionHeader
        chapter="01 — The Offer"
        title="One Name. Three Superpowers."
        sub="The 360 in RealEstateHero360 stands for the full circle: tours, flights, and clips — every format custom-made for your company."
      />

      <div className="grid gap-8 md:grid-cols-3">
        {PILLARS.map((p, i) => (
          <Reveal key={p.title} delay={i * 0.15}>
            <article
              className="group h-full rounded-md border-2 border-hero-black/10 bg-hero-cream p-8 shadow-md transition-all duration-300 ease-out hover:-translate-y-2 hover:border-hero-black hover:shadow-xl"
              data-testid={`offer-card-${i + 1}`}
            >
              <div className="inline-flex rounded-md bg-hero-blue p-3 text-white transition-colors duration-300 group-hover:bg-hero-gold group-hover:text-hero-black">
                <p.icon className="h-7 w-7" aria-hidden="true" />
              </div>
              <h3 className="mt-5 font-display text-2xl font-bold uppercase tracking-tight text-hero-black sm:text-3xl">
                {p.title}
              </h3>
              <p className="mt-3 text-base leading-relaxed text-hero-black/70">{p.text}</p>
              <ul className="mt-6 space-y-2 border-t-2 border-hero-black/10 pt-5">
                {p.examples.map((ex) => (
                  <li key={ex} className="flex items-center gap-2 text-sm font-semibold text-hero-black/80">
                    <span className="h-1.5 w-1.5 rounded-full bg-hero-gold" aria-hidden="true" />
                    {ex}
                  </li>
                ))}
              </ul>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
